module.exports = __webpack_public_path__ + "static/img/gong_code.f7231f3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gong_code.jpeg
// module id = iHvQ
// module chunks = 1